import createInsertButtons from './insert-buttons.js';
import '../constants.js';
import 'react';
import '../icons/FaBell.js';
import '../icons/FaFlag.js';
import '../icons/FaHeart.js';
import '../icons/FaPaw.js';
import '../icons/FaSmile.js';
import '../icons/FaPlane.js';
import '../icons/FaUtensils.js';
import '../icons/FaRegFutbol.js';
import 'wix-rich-content-editor-common';
import './emojiInsertModal.js';
import '../modifiers/addEmoji.js';
import '../types.js';
import './emojiPreviewModal.js';
import 'prop-types';
import 'react-custom-scrollbars';
import 'wix-rich-content-common';
import '../icons/JoyPixelsIcon.js';
import '../utils/getGroupEmojis.js';
import '../utils/convertUnicodeToEmoji.js';
import '../utils/emojiList.js';
import 'wix-rich-content-ui-components';
import '../icons/EmojiPluginIcon.js';

const createToolbar = ({
  settings,
  t,
  isMobile,
  getEditorState,
  setEditorState
}) => {
  return {
    InsertButtons: isMobile ? [] : createInsertButtons({
      settings,
      t,
      isMobile,
      getEditorState,
      setEditorState
    }),
    name: "emoji"
  };
};

export { createToolbar as default };
//# sourceMappingURL=createToolbar.js.map
